import { type AllIconsList, type IconData } from './types';

export const sortIntoCategories: (icons: IconData[]) => AllIconsList = (icons: IconData[]) => {
	// e.g. @atlaskit/icon-object/glyph/branch/24
	const categorisedIcons = {
		'16': [],
		'24': [],
	} as AllIconsList;
	const sizes = ['16', '24'];
	const numbersRegex = /\d+/g;
	icons.forEach((icon) => {
		const size = icon.componentName.match(numbersRegex)?.[0]; // componentName example = Branch24Icon
		if (size && sizes.includes(size)) {
			categorisedIcons[size].push(icon);
		}
	});
	return categorisedIcons;
};
